import $ from 'jquery'
import Masonry from 'masonry-layout'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.team-block__masonry')

  new Masonry(wrapper[0], {
    itemSelector: '.feed-team',
    columnWidth: '.team-block__team-sizer',
    percentPosition: true,
  })
}

$('.team-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=vn-team', initializeBlock)
}
